import { ModelValidatorRule } from './model-validator-rule';
import { ValidatorBase } from '../../../../utilities/validation/validator-base';

export class ModelValidator<TModel, TMetadata> extends ValidatorBase {
  private _model: TModel;
  get model(): TModel {
    return this._model;
  }

  constructor(model: TModel) {
    super();
    this._model = model;
  }

  ruleFor<TInput>(
    source: (model: TModel) => TInput,
    key: string,
    metadata: TMetadata,
  ): ModelValidatorRule<TModel, TInput, TMetadata> {
    const existingRule = this.getRule(key);
    if (existingRule) {
      throw `A validation rule for key ${key} has already been created`;
    }

    const rule = new ModelValidatorRule(this, key, source, metadata);
    this.addRule(rule, key);
    return rule;
  }
}
